import { getJSONStorage } from 'src/lib/storage';
import StorageKeys from 'src/lib/storage/storageKeys';
import { resolveTenancy } from '../../tenancy';
import { getDefaultDebugSettingsState } from './utils';
const storage = getJSONStorage(StorageKeys.debugSettings.scope);
const debugSettingsStorage = {
    getSettings() {
        const defaults = getDefaultDebugSettingsState();
        const stored = storage.get(StorageKeys.debugSettings.key);
        if (!stored)
            return defaults;
        // Older installs predate tenancy; keep their env and fill the new field.
        return {
            ...defaults,
            ...stored,
            tenancy: resolveTenancy(stored.tenancy, defaults.tenancy),
        };
    },
    setSettings(settings) {
        storage.set(StorageKeys.debugSettings.key, settings);
    },
};
export default debugSettingsStorage;
